import { Stack } from "expo-router";

/* Nested stack keeps the parent header and back button. */
export default function LeaveRequestLayout() {
    return (
        <Stack
            screenOptions={{
                headerShown: false,
            }}
        />
    );
}
